import { Validness } from '../types/validness';

export const isValidnessInvalid = <T extends Validness<{}>>(validness: T) => {
    return Object.values(validness).some(Boolean);
};
